import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { apiServices } from './ApiServiceProvider';
import MultiSourceTab from '../../../../Components-2025/IR/Quiz/MultiSourceTab';
import ReverseTimer from '../../../../Components-2025/IR/Quiz/ReverseTimer';
import GraphicalStatement from '../../../../Components-2025/IR/Quiz/GraphicalStatement';
import TableAnalysisTwoStatement from '../../../../Components-2025/IR/Quiz/TableAnalysisTwoStatement';
import TwoPartAnalysis from '../../../../Components-2025/IR/Quiz/TwoPartAnalysis';
import NormalQuestion from '../../../../Components-2025/IR/Quiz/NormalQuestion';
import AppRoutes from '../../../config/AppRoutes';
import { examNameAccordingToDB } from '../../../../common/constant';
export default class BeginQuizContainer extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      currentQuestion: {},
      validated: false,
      timer: props.params.timer || 0,
    };
  }

  async componentDidMount() {
    const { router } = this.context;

    const { params, questionType: question_type } = this.props;
    const { quiz_id, type, offset } = params;
    const payload = {
      quiz_id,
    };
    const response = await apiServices.getQuizDetails(payload);

    // Parse nested JSON once
    const parsedQuiz = JSON.parse(JSON.parse(JSON.stringify(response.singlequiz)));
    const { all_questions: questionIds, readings: questionTypes } = parsedQuiz;

    // Timer values
    const quizTime = response.timer_value;
    const userSpendTime = response.user_time_value;

    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];
    this.setState({
      questionIds,
      questionTypes,
      quizTime,
      userSpendTime,
      currentQuestionId,
      currentQuestionType,
      timer: userSpendTime || quizTime,
      isValidate: false,
    });
  }
  handleChangeParams = (index) => {
    const { questionTypes, questionIds } = this.state;
    const {
      params: { quiz_id, timer },
    } = this.props;
    const currentQuestionType = questionTypes[index];
    const currentQuestionId = questionIds[index];

    this.setState({ currentQuestionType, currentQuestionId });
    this.context.router.push({
      pathname: AppRoutes.EA_BEGIN_QUIZ.replace(':quiz_id', quiz_id)
        .replace(':offset', index)
        .replace(':type', currentQuestionType)
        .replace(':timer', timer),
    });
  };
  redirectToResults = (status) => {
    const { router } = this.context;
    const {
      params: { quiz_id },
    } = this.props;

    router.push({
      pathname: AppRoutes.EA_BEFORE_START.replace(':quiz_id', quiz_id).replace(
        ':status_send',
        status || 'abondon',
      ),
    });
  };
  onHandleSetTimer = (isTimer, isValidate) => this.setState({ isTimer, isValidate });
  updateUserTimer = (time) => {
    const { params } = this.props;

    const payload = {
      quiz_id: params.quiz_id,
      user_time_value: time.timer,
    };
    apiServices.insertUserTimer(payload).then((response) => {
      this.setState({ timer: time.timer });
    });
  };
  render() {
    const { currentQuestionType, questionIds, questionTypes, isTimer, timer, isValidate } =
      this.state;
    if (!currentQuestionType || Object.keys(currentQuestionType).length === 0) {
      return null;
    }

    const commonProps = {
      ...this.props,
      questionTypes,
      questionType: currentQuestionType,
      apiServices,
      questionIds,
      handleChangeParams: this.handleChangeParams,
      redirectToResults: this.redirectToResults,
      onHandleSetTimer: this.onHandleSetTimer,
      examName: examNameAccordingToDB.EA,
    };

    const reverseTimer = (
      <ReverseTimer
        initialTimerValue={timer}
        isTimerRunning={isTimer}
        apiCall={this.updateUserTimer}
        onStartTimer={() => this.setState({ isTimer: true })}
        onStopTimer={() => this.setState({ isTimer: false })}
        onToggleTimer={() => this.setState((prev) => ({ isTimer: !prev.isTimer }))}
        disabled={isValidate}
      />
    );

    const questionTypeMap = {
      tab_question: MultiSourceTab,
      graph_question: GraphicalStatement,
      table_question: TableAnalysisTwoStatement,
      two_part_question: TwoPartAnalysis,
      question: NormalQuestion,
      case_question: NormalQuestion,
    };

    const QuestionComponent = questionTypeMap[currentQuestionType];

    if (!QuestionComponent) return null;

    return (
      <span>
        <QuestionComponent {...commonProps}>{reverseTimer}</QuestionComponent>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/EA-Exams/Quizzes/BeginQuiz/BeginQuizContainer.js